





































































import { Component, Vue } from "vue-property-decorator";
import BeginVerificationSvg from "@/modules/welcome/components/BeginVerificationSvg.vue";
import BeginVerificationDesktopSvg from "@/modules/welcome/components/BeginVerificationDesktopSvg.vue";
import PreviousPageArrow from "@/components/PreviousPageArrow.vue";
import DetectRTC from "detectrtc";

import axios from "axios";

@Component({
  metaInfo() {
    return {
      title: "Orba One | Welcome",
    };
  },
  components: {
    "begin-verification-svg": BeginVerificationSvg,
    "begin-verification-desktop-svg": BeginVerificationDesktopSvg,
    "previous-page-arrow": PreviousPageArrow,
  },
})
export default class Welcome extends Vue {
  webRtcSupported = true;
  isWebsiteHasWebcamPermissions = false;
  isWebsiteHasMicrophonePermissions = false;
  welcomePlayed = false;

  beforeMount() {
    DetectRTC.load(function () {
      console.log("Loaded");
    });
    this.sendStartFlag();
  }

  sendStartFlag() {
    if (!DetectRTC.isWebRTCSupported) {
      this.webRtcSupported = false;
      return;
    }

    console.log(DetectRTC);

    const params = new URLSearchParams(window.location.search);
    const publicKey = params.get("publicKey");
    const applicantId = params.get("applicantId");
    const magicLink = params.get("magic");

    if ((publicKey && applicantId) || magicLink) {
      axios.post(
        `${process.env.VUE_APP_API_URL}/applicants/${applicantId}/start`,
        {
          applicantId,
          publicKey,
          magic: magicLink,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
    }
  }

  async mounted() {
    // Listen for mouse movement event
    if (Vue.prototype.$useAudioInstructions) {
      // Wait for 3 seconds
      await new Promise((resolve) => setTimeout(resolve, 3000));
      // Call the playWelcome function after 3 seconds
      await Vue.prototype.$audioConfigs.playWelcome();
    }
  }

  async handleMouseMove() {
    // Execute playWelcome() only if it hasn't been triggered before
    if (!this.welcomePlayed && Vue.prototype.$useAudioInstructions) {
      await Vue.prototype.$audioConfigs.playWelcome();
      this.welcomePlayed = true; // Set the flag to true after playing welcome
    }
  }
  async handleScreenTouch() {
    // Execute playWelcome() only if it hasn't been triggered before
    if (!this.welcomePlayed && Vue.prototype.$useAudioInstructions) {
      await Vue.prototype.$audioConfigs.playWelcome();
      this.welcomePlayed = true; // Set the flag to true after playing welcome
    }
  }

  beforeUnmount() {
    if (Vue.prototype.$useAudioInstructions) {
      Vue.prototype.$audioConfigs.stopWelcome();
    }
  }

  gotoTermsOfService(event) {
    this.startVerification();
    this.$router.push({
      name: "termsOfService",
      query: this.$route.query, // <-- forward query params
    });
    if (Vue.prototype.$useAudioInstructions) {
      Vue.prototype.$audioConfigs.stopWelcome();
    }
  }

  startVerification() {
    const params = new URLSearchParams(window.location.search);
    const publicKey = params.get("publicKey");
    const applicantId = params.get("applicantId");
    const magicLink = params.get("magic");
    const progressionStep = 1;

    if ((publicKey && applicantId) || magicLink) {
      axios.put(
        `${process.env.VUE_APP_API_URL}/applicants/${applicantId}/verification-progress-step`,
        {
          publicKey,
          progressionStep,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
    }
  }
}
